export default "__VITE_ASSET__CUW78ztP__"